<template>
    <div>
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item
                            icons
                            router
                            :to="item.path"
                            v-for="item in racourcis"
                            :key="item.text"
                            :disabled="item.disabled"
                    >{{ item.text }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

        <v-layout wrap>
            <v-flex xs12>
                <v-card style="width:100%" class="mb-3">
                    <v-card-text fluid grid-list-md>
                        <h3>Liste des budgets projet</h3>
                        <v-divider class="mb-2"></v-divider>
                    </v-card-text>
                </v-card>
                <v-layout row>
                    <v-flex xs4>
                        <v-chip style="font-size:15px" label outline
                                color="primary"><b>TOTAL MONTANT PROPOSE
                            : {{ new
                            Intl.NumberFormat().format(totalMntPropose)
                            }} </b></v-chip>
                    </v-flex>

                    <v-flex xs4>
                        <v-chip style="font-size:15px" label outline
                                color="primary"><b>TOTAL MONTANT VALIDE
                            : {{ new
                            Intl.NumberFormat().format(totalMntValide)
                            }} </b></v-chip>
                    </v-flex>

                    <v-flex xs4>
                        <v-chip style="font-size:15px" label outline
                                color="primary"><b>TOTAL MONTANT MARCHE
                            : {{ new
                            Intl.NumberFormat().format(totalMntMarche)
                            }} </b></v-chip>
                    </v-flex>
                </v-layout>

                <data-tables

                        border
                        :header-row-style="headerRowStyle"
                        highlight-current-row
                        :data="listeProjet"
                        :summary-method="getSummExploitBudget"
                        show-summary
                        style="width: 100%"
                >


                    <el-table-column  align="center" sortable  prop="libelle"
                                      label="PROJET">
                        <template
                                slot-scope="prop"
                        >
                            <span class="subheading black--text" > {{prop.row.libelle}}  </span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" sortable prop="mntTotalProjetPropose" label="MONTANT TOTAL PROPOSE">
                        <template
                                slot-scope="prop4"
                        >
                            <el-tag class="subheading" type="blue">
                                {{ new Intl.NumberFormat().format(prop4.row.mntTotalProjetPropose)}}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column  align="center" sortable  prop="mntTotalProjetValide" label="MONTANT TOTAL VALIDE">
                        <template
                                slot-scope="prop5"
                        >
                            <el-tag class="subheading" type="success">
                                {{ new Intl.NumberFormat().format(prop5.row.mntTotalProjetValide)}}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="ETAT"
                            prop="etat">
                        <template slot-scope="scope">
                            <el-tag
                                    :type="scope.row.etat == 0 ? 'warning' : 'success'"
                                    disable-transitions>{{scope.row.libEtatBudget}}</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column  align="center" sortable  prop="mntMarche" label="MONTANT DU MARCHE">
                        <template
                                slot-scope="prop"
                        >
                            <el-tag class="subheading" type="info">
                                {{ new Intl.NumberFormat().format(prop.row.mntMarche)}}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <!--<el-table-column  align="center" sortable  prop="ecart" label="ECART">-->
                        <!--<template-->
                                <!--slot-scope="prop3"-->
                        <!--&gt;-->
                            <!--<el-tag   class="subheading":type="prop3.row.ecart < 0 ? 'danger' : 'success'">-->
                                <!--{{ new Intl.NumberFormat().format(prop3.row.ecart)}}-->
                            <!--</el-tag>-->

                        <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column  align="center" sortable prop="evolution" label="EVOLUTION(%)">-->
                        <!--<template-->
                                <!--slot-scope="prop2"-->
                        <!--&gt;-->
                            <!--<el-progress :percentage="Number.parseFloat(prop2.row.evolution).toFixed(2)"-->
                                         <!--:color="Number.parseFloat(prop2.row.evolution).toFixed(2) >= 50 ? '#76FF03': 'blue'" :format="format">-->
                            <!--</el-progress>-->

                        <!--</template>-->
                    <!--</el-table-column>-->

                    <el-table-column label="Action" align="center" fixed="right">
                        <template slot-scope="scope">
                            <v-tooltip top>
                                <v-btn
                                        v-if="scope.row.etatBudget != 3"
                                        slot="activator"
                                        @click="modalDetailProj(scope.row)"
                                        fab
                                        dark
                                        small
                                        color="blue"
                                >
                                    <v-icon dark>list</v-icon>
                                </v-btn>Detail du projet
                            </v-tooltip>

                        </template>
                    </el-table-column>

                </data-tables>
            </v-flex>






        </v-layout>

        <DetailBudgetProjet :show="showDetailProj"  :detailProjet="detProj" @close="showDetailProj = false; loadBudget()" ></DetailBudgetProjet>

    </div>
</template>

<script>
    import Loading from "@/components/Loading";
    import DetailBudgetProjet from "@/components/projet/DetailBudgetProjet"
    export default {
        name: "BudgetProjet.vue",
        components: {
            Loading,
            DetailBudgetProjet
        },
        data(){
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,
                racourcis: [
                    {path: "/budgetProjet", text: "Budget projet", disabled: false}
                ],

                listeProjet: [],
                detProj: {},
                showDetailProj :  false,
                totalMntPropose: 0,
                totalMntValide: 0,
                totalMntMarche: 0

            }
        },
        methods: {
            modalDetailProj(itemProjet){
                this.detProj = itemProjet
                this.showDetailProj = true
            },

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            loadBudget(){
                //this.loading = true;
                let url = this.domaine + "compteExploit/budget/projet";
                this.$http.get(url).then(
                    resp=>{
                        this.listeProjet = resp.body.budgetsProjet;
                        this.totalMntPropose = resp.body.mntTotalBugPropose;
                        this.totalMntValide = resp.body.mntTotalBugValide;
                        this.totalMntMarche = resp.body.mntTotalBugMarche;
                    },
                    error=>{
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement des budget"
                        );
                    }
                )

            },
            getSummExploitBudget(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 3) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
        },

        mounted()
        {
            this.loadBudget();
        }
    }



</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projet/BudgetProjet.vue